export default __webpack_public_path__ + "runways_logo.e43d7f84.png";